module.exports = __webpack_public_path__ + "static/northwestern.eb344b43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/highered_logos/northwestern.png
// module id = 2193
// module chunks = 61762850755587